<template>
  <span>{{ value }}</span>
</template>

<script>
export default {
  name: 'CountUp',
  props: {
    to: {
      type: Number,
      required: true
    },
    duration: {
      type: Number,
      default: 1400
    }
  },
  data() {
    return {
      value: this.to
    }
  },
  mounted() {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    if (reduceMotion || !('IntersectionObserver' in window)) {
      return
    }
    this.value = 0
    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.observer.disconnect()
          this.animate()
        }
      },
      { threshold: 0.6 }
    )
    this.observer.observe(this.$el)
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect()
    }
    cancelAnimationFrame(this.frame)
  },
  methods: {
    animate() {
      const start = performance.now()
      const step = now => {
        const progress = Math.min((now - start) / this.duration, 1)
        const eased = 1 - Math.pow(1 - progress, 3)
        this.value = Math.round(eased * this.to)
        if (progress < 1) {
          this.frame = requestAnimationFrame(step)
        }
      }
      this.frame = requestAnimationFrame(step)
    }
  }
}
</script>
